export const replaceDiacriticsInString = (value) => {
  return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
